module.exports = __webpack_public_path__ + "media/30.a070fb76.mp3";